import { Component, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'emm-confirm-restore-pins-dialog',
    templateUrl: './confirm-restore-pins-dialog.component.html',
    styleUrls: ['./confirm-restore-pins-dialog.component.scss'],
    standalone: false
})
export class ConfirmRestorePinsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmRestorePinsDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  handleConfirm() {
    this.data.restore(this.data.model, this.data.endDate, this.data.tomorrow, this.data.apiService, this.data.notificationService,
        this.data.dialog, this.data.werePinsReset);
  }
}
